module.exports = __webpack_public_path__ + "img/MasterCard.66a245f5.png";